export type BadgeColor = "primary" | "error";

/**
 * Props for the Badge component
 * @property {BadgeColor} [color] - The color state of the badge
 * @property {number} [value] - The numeric value to display. If provided, shows label variant; otherwise shows dot variant
 * @property {string} [testId] - Optional test ID for testing
 * @property {string} [className] - Optional className for additional styling (e.g., positioning)
 */
interface BadgeProps {
  color?: BadgeColor;
  value?: number;
  testId?: string;
  className?: string;
}

const colorClasses = {
  primary: {
    background: "bg-sys-brand-primary",
    text: "text-sys-brand-on-primary"
  },
  error: {
    background: "bg-sys-brand-error",
    text: "text-sys-brand-on-error"
  }
};

const variantClasses = {
  dot: "w-2 h-2",
  label: "h-4 min-w-[1rem] px-1 text-label-small"
};

export default function Badge({ color = "primary", value, testId, className = "" }: BadgeProps) {
  const colorClass = colorClasses[color];

  const variantClass = value != null ? variantClasses.label : variantClasses.dot;

  return (
    <span
      data-testid={testId}
      className={`${colorClass.background} ${colorClass.text} ${variantClass} rounded-full flex items-center justify-center tracking-wider ${className}`}
    >
      {value}
    </span>
  );
}
